// this file is automatically generated by git.version.ts script
export const versions = {commit: '492cf213', tag: '2026.3.003-RELEASE'};
